import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { captureExceptionWithLabel } from "../../utils/captureExceptionWithLabel";
import { Profile } from '@tokenlon/sdk';
import { useCallback } from 'react';
import { Mainnet, Goerli } from "../../model/chain/ethereum";
import { useAppDispatch, useAppSelector } from "../hooks";
import { updatePoolShares } from "./actions";
import { useWeb3React } from '@web3-react/core';
import { useUpdaterChainId } from "../../hooks";
export var usePoolShareUpdater = function usePoolShareUpdater() {
  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account,
      chainId = _useWeb3React.chainId;

  var dispatch = useAppDispatch();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var supportedChainIds, poolShares;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!account || !chainId)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            supportedChainIds = [Mainnet.chainId, Goerli.chainId]; // @todo SDK support ArbitrumOne chain

            if (supportedChainIds.includes(chainId)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.prev = 5;
            _context.next = 8;
            return Profile.getReferralPool({
              address: account,
              chainId: chainId
            });

          case 8:
            poolShares = _context.sent;
            dispatch(updatePoolShares({
              chainId: chainId,
              poolShares: poolShares
            }));
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](5);
            captureExceptionWithLabel('update pool shares error', _context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 12]]);
  })), [account, chainId, dispatch]);
};
export var useTotalEqualLon = function useTotalEqualLon() {
  var _useWeb3React2 = useWeb3React(),
      chainId = _useWeb3React2.chainId;

  return useAppSelector(function (state) {
    var _state$user$poolShare, _state$user$poolShare2;

    return (_state$user$poolShare = (_state$user$poolShare2 = state.user.poolShares[chainId]) === null || _state$user$poolShare2 === void 0 ? void 0 : _state$user$poolShare2.totalEqualLon) !== null && _state$user$poolShare !== void 0 ? _state$user$poolShare : 0;
  });
};
export var useFeeFactor = function useFeeFactor() {
  var _useWeb3React3 = useWeb3React(),
      chainId = _useWeb3React3.chainId;

  return useAppSelector(function (state) {
    var _state$user$poolShare3, _state$user$poolShare4;

    return (_state$user$poolShare3 = (_state$user$poolShare4 = state.user.poolShares[chainId]) === null || _state$user$poolShare4 === void 0 ? void 0 : _state$user$poolShare4.feeFactor) !== null && _state$user$poolShare3 !== void 0 ? _state$user$poolShare3 : 0;
  });
};
export var useConnectType = function useConnectType() {
  return useAppSelector(function (state) {
    return state.user.connectWallet;
  });
};
export var useSelectedConnectionType = function useSelectedConnectionType() {
  return useAppSelector(function (state) {
    return state.user.selectedConnectionType;
  });
};
export var usePendingChainId = function usePendingChainId() {
  var expectedChainId = useUpdaterChainId();
  return useAppSelector(function (state) {
    var _state$user$pendingCh;

    return (_state$user$pendingCh = state.user.pendingChainId) !== null && _state$user$pendingCh !== void 0 ? _state$user$pendingCh : expectedChainId;
  });
};